export default `float de(vec3 p){
    vec3 n = vec3(0.,1.,0.);       
    float distanceFromOrigin = 0.; 

    return dot(p, n) + distanceFromOrigin;
  }`